export const protectionData = {
  ES: {
    image: "/assets/imgs/protection/fondo.png",
    title: "PROTECCIÓN PROFESIONAL",
    description: [
      "En HISOL, contamos con un equipo certificado en rope access para limpieza, mantenimiento y restauración en altura.",
      "Nuestros técnicos con certificaciones IRATA y SPRAT garantizan seguridad y eficiencia en cada proyecto, cumpliendo con los más altos estándares de la industria.",
      "Seguridad, precisión y resultados excepcionales."
    ],
    images: [
      "/assets/imgs/protection/gallery/1.svg",
      "/assets/imgs/protection/gallery/2.svg"
    ]
  },
  EN: {
    image: "/assets/imgs/protection/fondo.png",
    title: "PROFESSIONAL PROTECTION",
    description: [
      "At HISOL, we have a certified rope access team for high-altitude cleaning, maintenance, and restoration.",
      "Our technicians, certified by IRATA and SPRAT, ensure safety and efficiency on every project, meeting the highest industry standards.",
      "Safety, precision, and exceptional results."
    ],
    images: [
      "/assets/imgs/protection/gallery/1.svg",
      "/assets/imgs/protection/gallery/2.svg"
    ]
  }
};